import invert from "lodash/invert";
import mapValues from "lodash/mapValues";

import {
  ARBITRUM,
  ASSETCHAIN,
  ASSETCHAIN_TESTNET,
  AVALANCHE,
  AVALANCHE_FUJI,
  BOTANIX,
  UiContractsChain,
} from "config/chains";

export const NETWORK_QUERY_PARAM = "network";
export const VERSION_QUERY_PARAM = "v";

export const NETWORK_ID_SLUGS_MAP: Record<UiContractsChain, string> = {
  [ARBITRUM]: "arbitrum",
  [AVALANCHE]: "avalanche",
  [AVALANCHE_FUJI]: "avalanche_fuji",
  [BOTANIX]: "botanix",
  [ASSETCHAIN]: "assetchain",
  [ASSETCHAIN_TESTNET]: "assetchain_testnet",
};

export const NETWORK_SLUGS_ID_MAP = mapValues(invert(NETWORK_ID_SLUGS_MAP), Number);
